import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import zh from './locales/zh.json'

const resources = {
  en: {
    translation: en
  },
  zh: {
    translation: zh
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      // Shell is a shared package — the consuming app is responsible for
      // persisting the language choice to localStorage with a prefixed key
      // (e.g. 'helpdesk:i18nextLng'). Shell only detects, never caches.
      order: ['navigator', 'htmlTag'],
      caches: []
    }
  })

export default i18n 